// Testing SINGLE!!!!

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
//import App from './App'

//import citationtool from './tool.js'

//used to translate from zotero to csl-json
const translator = require('zotero-to-csl')

const axios = require('axios');

var Raven = require('raven-js')     ;
Raven
    .config('https://372aca41a10640b19688ed7e2e366a28@sentry.io/1225734')
    .install();

import csl from 'script-loader!../static/citeproc.js'

import xml from '../static/locales/locales-en-US.xml'

// Really Bad, Remove these asap!
import mla from '../static/styles/mla.csl'
import apa from '../static/styles/apa.csl'
import chicago from '../static/styles/chicago.csl'
import harvard from '../static/styles/harvard.csl'

const bookSectionFields = require('../static/itemFields/bookSection');
const webpageFields = require('../static/itemFields/webpage');

const bookCreatorFields = require('../static/creatorFields/books');
const webpageCreatorFields = require('../static/creatorFields/webpage');

const mlaBookBlackList = require('../static/blacklists/mlaBook');
const mlaWebsiteBlackList = require('../static/blacklists/mlaWebsite');

const itemTypes = require('../static/itemTypes/all');

var isURL = /[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&\/\/=]*)/;

/* eslint-disable no-new */
var app = new Vue({
  el: '#app',
  data: {

    citationObjects: [],
    currentCitation: null,
    
    activeStyleName: 'MLA 8',
    activeStyle: '',
    availableStyles: ['MLA 8', 'APA', 'Chicago', 'Harvard'],

    activeEdit: null,
    activeEditIndex: null,
    displayEdit: false,
    activeEditFields: webpageFields,
    activeBlackList: [],
    activeCreatorFields: webpageCreatorFields,
    
    generatedCitations:[],

    // Used For Downloads and Copy All
    fullBibliography:[],

    errors: [],
    lastDeleted: null,
    citationCreated: false,

    manualCitation: false,
    manualCitationFields: {},
    manualCitationType: 'bookSection',
    sourceTypeDisplay: "Book",
    primaryCreatorType: '',
    itemTypes: itemTypes,
    citationURL: '',

    activeBookResults: [],

    searchableSource: "Website",
    searchItem: "",
    
    greenHighlight: false,

    loading: 0,
    bookLoading: false,
    copyAllSuccess: false,

    citeprocSys: {

      retrieveLocale: function (lang){
          return xml
      },
    
      retrieveItem: function(id){
          return app.currentCitation[id];
      }
    },

    serverURL: '',

    citeproc: ''

  },
  methods: {

    primeEngine: function() {
      this.citeproc = new CSL.Engine(this.citeprocSys, this.activeStyle);
    },
    
    cite: function() {

      if (this.searchableSource == "Website") {
        this.citeWebsite();
      } else if (this.searchableSource == "Books") {
        this.citeBook();
      } else {
        this.newManualCitation(this.searchableSource);
      }

    },
    citeWebsite: function() {

      var _this3 = this;

      //var websites = this.searchItem.split(' ');

      var site = this.searchItem;

      //websites.forEach((site) => {

        // Verify Not Empty
        if (!site) {
          return;
        }

        // Verify URL
        if (!isURL.test(site)) {
          //var error = { 'error': site, 'type': 'nonURL' };
          //this.errors.unshift(error);

          this.citeBook(site);

          return;
        }

        this.loading += 1;

        var params = new URLSearchParams();
        params.append('url', site);

        axios.post(this.serverURL + 'api/website', params).then((res) => {

          if (res.data.length == 1) {
  
            var error = { 'error': res.data[0], 'type': 'httpERROR' };
            this.errors.unshift(error);

            this.loading -= 1;

            return;
  
          }
          
          this.addItem(res.data);
          this.searchItem = '';
          _this3.loading -= 1;
  
        }).catch((err) => {
  
          console.log(err)

          var error = { 'error': "Network Error", 'type': 'httpERROR' };
          this.errors.unshift(error);

          _this3.loading -= 1;
  
        })

      //});

     // this.loading = false 

    },
    citeBook: function() {

      // Check if Search is actually a Website
      if (isURL.test(this.searchItem)) {
        this.citeWebsite();
        return;
      }
      
      this.bookLoading = true;
      
      var params = new URLSearchParams();
      params.append('book', this.searchItem);

      axios.post(this.serverURL + 'api/books', params).then((res) => {
        
        if (res.data.length > 0) {
          this.activeBookResults = res.data;
        } else {
          var error = { 'error': this.searchItem, 'type': 'bookERROR' };
          this.errors.unshift(error);
          this.bookLoading = false;
        }
        

      }).catch((err) => {

        console.log(err)
        Raven.captureException(e);
        this.bookLoading = false;

      })

      this.bookLoading = false;

    },

    saveFormFields: function(template,fields,creators) {

      var type = template.itemType;

      var tmp = {};
      tmp.template = template
      tmp.fields = fields
      tmp.creators = creators

      localStorage.setItem(type, JSON.stringify(tmp));

    },

    changeStyle: function() {
      
      this.loading = true;
      
      if (this.activeStyleName == "MLA 8") this.activeStyle = mla;
      else if (this.activeStyleName == "APA") this.activeStyle = apa;
      else if (this.activeStyleName == "Chicago") this.activeStyle = chicago;
      else if (this.activeStyleName == "Harvard") this.activeStyle = harvard;
 
      this.citeproc = new CSL.Engine(this.citeprocSys, this.activeStyle);
      this.reformatCitations();

      this.saveToLocalStorage();

      this.loading = false;

    },

    reformatCitations: function() {

      this.citationObjects.forEach(container => {

        container.citation = this.generateSingleCitation( container.cslData )
        
      });

    },

    addAuthor: function() {


      // TODO, Should not assume "author"
      var newAuthor = {
        "creatorType": this.primaryCreatorType,
        "firstName": "",
        "lastName": ""
      }

      this.activeEdit.creators.push(newAuthor);

    },

    removeAuthor: function(index) {

      this.activeEdit.creators.splice(index,1);

    },

    ///////////////////////////////
    // Manual Citation Functions //
    ///////////////////////////////

    changeSourceType: function(localized, type) {

      this.manualCitationType = type;
      this.sourceTypeDisplay = localized;

      this.switchFormType()

    },

    switchFormType: function() {
    // Should transfer over existing fields
    // Re-render Form Inputs

    delete this.activeEdit.itemType;

    this.manualCitationFields = this.activeEdit;

    this.setFormFields(this.manualCitationType, true);

    },

    saveManualCitation: function() {
    // Adds Manual Citation 

      this.addItem(this.activeEdit);

      // Close and reset variables
      this.displayEdit = false;
      this.manualCitation = false;

    },

    newManualCitation: async function(title) {

      // Clear saved fields
      this.manualCitationFields = {};

      this.manualCitation = true;
      
      // Render Form -- Default to bookSection
      await this.setFormFields(this.manualCitationType, true);

      if (title) {

        if (this.activeEdit.itemType == "statute") this.activeEdit.nameOfAct = this.searchItem;
        else if (this.activeEdit.itemType == "email") this.activeEdit.subject = this.searchItem;
        else if (this.activeEdit.itemType == "case") this.activeEdit.caseName = this.searchItem;
        else this.activeEdit.title = this.searchItem;
        
      }

      this.displayEdit = true;

    },

    /////////
    // END //
    /////////

    saveEdits: function() {

      if (this.manualCitation) {
        this.saveManualCitation();
        this.saveToLocalStorage();
        return;
      }

      var index = this.activeEditIndex;

      var editObject = this.citationObjects[index];

      editObject.zoteroData = this.activeEdit;
      // ##TODO## Delete object if empty. 
      //editObject.zoteroData.creators = this.activeAuthorObject;

      // Convert Zotoro Data to CSL-JSON
      editObject.cslData = this.zoteroToCSL(editObject.zoteroData, editObject.key); 

      // Generate Formatted Citation
      editObject.citation = this.generateSingleCitation( editObject.cslData );

      // If citation is empty, delete Citation Object.
      // else save citation
      if (!editObject.citation) {
        this.deleteItem( index );
      } else {
        this.citationObjects[index] = editObject;
      }

      this.displayEdit = false;

      // reset variables
      this.activeEdit = null;
      
      this.activeBlackList = [];

      this.saveToLocalStorage();

    },

     getFieldsZotero: function(type) {

        var data = axios.all([

        axios.get('https://api.zotero.org/items/new', {
          params: {
            itemType: type
          }
        }),
        axios.get('https://api.zotero.org/itemTypeFields', {
          params: {
            itemType: type
          }
        }),
        axios.get('https://api.zotero.org/itemTypeCreatorTypes', {
          params: {
            itemType: type
          }
        })

      ]).then(axios.spread((template,fields,creators)=> {

        this.saveFormFields(template.data, fields.data, creators.data);

        return { template:template.data,
                 fields: fields.data, 
                 creators: creators.data}

      }))

      return data
    
    },

    setFormFields: async function(type, manual) {

      var data

      if (localStorage.getItem(type)) {

        console.log("Item Is Available");
        data = JSON.parse(localStorage.getItem(type))
        
      } else {

        console.log("Item Will Be Loaded/Saved");
        data = await this.getFieldsZotero(type)

      }

      this.primaryCreatorType = data.template.creators[0].creatorType

      // Populate template and fields if Manual Citation. 
      if (manual) {
  
        this.activeEdit = data.template;

        for (var key in this.activeEdit) {
  
          if (this.manualCitationFields[key]) {
            this.activeEdit[key] = this.manualCitationFields[key];
          } 
        }

        // iterate through authors and change creatortype
        this.activeEdit.creators.forEach((author) => {
        
            author.creatorType = this.primaryCreatorType

          }

        );

      }

      // TODO Should Populate blacklists in a more dynamic way
      if (this.activeStyleName == "MLA 8") {
        if (this.activeEdit.itemType == "webpage") this.activeBlackList = mlaWebsiteBlackList;
        else if (this.activeEdit.itemType == "bookSection") this.activeBlackList = mlaBookBlackList;
      } else {
        this.activeBlackList = [];
      }

      this.activeEditFields = data.fields
      this.activeCreatorFields = data.creators

    },

    editItem: function(index) {

      // get key value 
      var key = this.citationObjects[index].key;
      // set activeEdit Object
      this.activeEdit = this.citationObjects[ index ].zoteroData;
      this.activeEditIndex = index;

      var type = this.activeEdit.itemType;

      this.setFormFields(type);

      // Set active edit object, if exists.  
      if (this.activeEdit.creators.length == 0) {

        this.activeEdit.creators.push( 

          {
            "creatorType": this.primaryCreatorType,
            "firstName": "",
            "lastName": ""
          }

         );

      } 

      this.displayEdit = true;
      
    },

    copyAll: function() {

      this.renderFullBib();

      var orderedCitations = this.fullBibliography;
      var all = '';
      for (var i = 0; i < orderedCitations.length; i++) {
        var current = orderedCitations[i];
        all += current;
        all += '<br><br>';
      }

      var el = document.getElementById("toCopy");
      el.innerHTML = "<span>" + all + "</span>";

      try {
        var range = document.createRange();
        range.selectNodeContents(el);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);

        document.execCommand('copy');
        this.copyAllSuccess = true;
        console.log("here");
      } catch (e) {
        alert('Sorry, Your browser is not letting us copy for you.');
      }

      el.innerHTML = '';
    },

    renderFullBib: function () {

      this.currentCitation = {};

      this.citationObjects.forEach((citation) => {
        this.currentCitation[citation.cslData.id] = citation.cslData;
      })

      this.generateALLCitations();

    },

    // Used to generate FULL BIB when Copying or Downloading
    generateALLCitations: function() {

      var itemIDs = [];

      this.fullBibliography = [];

      for (var key in this.currentCitation) {
        itemIDs.push(key);
      }

      this.citeproc.updateItems(itemIDs);
      var bib = this.citeproc.makeBibliography()

      var output = bib[1];

      if (output) {
        output.forEach((citation) => {

          var generatedCitation = citation.slice(25,-7);

          generatedCitation = generatedCitation.replace("“", '"');
          generatedCitation = generatedCitation.replace("”", '"');

          this.fullBibliography.push(generatedCitation)

        });
      }

    },

    generateSingleCitation: function (cslItem) {

      this.currentCitation = {}
      this.currentCitation[cslItem.id] = cslItem;

      var itemID = [ cslItem.id ];

      this.citeproc.updateItems(itemID);
      var bib = this.citeproc.makeBibliography()
      
      var generatedCitation;

      if (bib[1][0]) {

        generatedCitation = bib[1][0].slice(25,-7);

      } else {

        generatedCitation = '';

      }

      return generatedCitation;

    },

    assignID: function () {

      var digit = Math.floor(1000 + Math.random() * 9000);

      var id = "Citation-" + digit.toString()

      return id

    },

    deleteItem: function (index) {

      var this5 = this;

      this.lastDeleted = this.citationObjects[index]

      this.citationObjects.splice(index, 1);

      this.saveToLocalStorage();

      setTimeout(function () {

        this5.lastDeleted = null;
          
      }, 5000);

    },

    undoDelete: function() {

      this.citationObjects.unshift(this.lastDeleted);
      this.lastDeleted = null;

      this.saveToLocalStorage();

    },

    zoteroToCSL: function(zotoroItem, key) {

      var cslItem = translator(zotoroItem);
      cslItem.id = key;

      return cslItem;

    },

    addItem: function (item) {

      var this5 = this;

      var key = this.assignID();

      var citeObject = {}
      citeObject.key = key;
      citeObject.zoteroData = item;

      citeObject.cslData = this.zoteroToCSL(item, key); 

      citeObject.citation = this.generateSingleCitation( citeObject.cslData );

      // Checks to make sure citation is not empty
      // Cancels adding if empty
      if (!citeObject.citation) {
        return;
      }

      this.citationObjects.unshift(citeObject);

      this.citationCreated = true;

      setTimeout(function() {

        this5.citationCreated = false;

      }, 3000)

      this.handleHighlight();

      this.saveToLocalStorage();

    },

    addBook: function(book) {

      this.addItem(book);

      //Sanity Check
      this.bookLoading = false;
      //Reset Book Results
      this.activeBookResults = [];

    },

    closeBookOverlay: function(index) {

      this.bookLoading = false;
      //Reset Book Results
      this.activeBookResults = [];

    },

    copyCitation: function copyCitation(index) {
      
      var el = document.getElementById("toCopy");
      el.innerHTML = "<span class='copy'>" + this.citationObjects[index].citation + " </span>";

      try {
        var range = document.createRange();
        range.selectNodeContents(el);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);

        document.execCommand('copy');
        
      } catch (e) {
        alert('Sorry, Your browser is not letting us copy for you.');
      }

      el.innerHTML = '';
    },

    handleHighlight: function(index) {
      var this5 = this;

      this.greenHighlight = true;

      setTimeout(function() {
        this5.greenHighlight = false;
      },3000)

    },

    downloadBibliography: function() {
      this.renderFullBib();

    
      try {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', this.serverURL + 'document/bibliography', true);
        xhr.responseType = 'arraybuffer';
        xhr.onload = function () {
            if (this.status === 200) {
                var filename = "";
                var disposition = xhr.getResponseHeader('Content-Disposition');
                if (disposition && disposition.indexOf('attachment') !== -1) {
                    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    var matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '');
                }
                var type = xhr.getResponseHeader('Content-Type');
                var blob;
                try {
                  if (typeof File == 'function') {
                    blob = new File([this.response], filename, { type: type })
                  } else {
                    blob = new Blob([this.response], { type: type });
                  }
                // Edge Work Around
                } catch(e) {
                  blob = new Blob([this.response], { type: type });
                }
                if (typeof window.navigator.msSaveBlob !== 'undefined') {
                  console.log("Here")
                  window.navigator.msSaveBlob(blob, filename);
                } else {
                    var URL = window.URL || window.webkitURL;
                    var downloadUrl = URL.createObjectURL(blob);
                    if (filename) {
                        // use HTML5 a[download] attribute to specify filename
                        var a = document.createElement("a");
                        // safari doesn't support this yet
                        if (typeof a.download === 'undefined') {
                            window.location = downloadUrl;
                        } else {
                            a.href = downloadUrl;
                            a.download = filename;
                            document.body.appendChild(a);
                            a.click();
                        }
                    } else {
                        window.location = downloadUrl;
                    }
                    setTimeout(function () { URL.revokeObjectURL(downloadUrl); }, 500); // cleanup
                }
            }
        };
        xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        var params = new URLSearchParams();
        params.append("citations", JSON.stringify(this.fullBibliography));
        params.append("header", this.bibliographyHeading);

        xhr.send(params);
      } catch(e) {
        console.log(e);
        Raven.captureException(e);
      }

    },
    saveToGoogleDrive: function() {
      this.renderFullBib();

      var object = {};

      object.citations = this.fullBibliography;
      object.header = this.bibliographyHeading;

      console.log(object)
      console.log(JSON.stringify(object))

      setCookie("drive-citations", JSON.stringify(object), 1);

    },

    // This needs to be changed ASAP. 
    // Really bad
    saveToLocalStorage: function() {

      localStorage.setItem('formatically-citations', JSON.stringify(this.citationObjects));
      localStorage.setItem('lastStyle', this.activeStyleName);

    },

    retrieveFromStorage: function() {

      if (localStorage.getItem('formatically-citations')) {
        this.citationObjects = JSON.parse(localStorage.getItem('formatically-citations'))
      }
      if (localStorage.getItem('lastStyle')) {
        this.activeStyleName = localStorage.getItem('lastStyle');
      }
    }

  },
  computed: {

    bibliographyHeading: function() {
      if (this.activeStyleName == "MLA 8") {
        return 'Works Cited';
      } else if (this.activeStyleName == "APA" || this.activeStyleName == "Harvard" ) {
        return 'References';
      } else {
        return 'Bibliography';
      }

    },

    handleCitationURL: function() {
      if (this.activeEdit.itemType == "webpage") {
        var url = this.activeEdit.url;

        if (!/^https?:\/\//i.test(url)) {
          url = 'http://' + url;
        }

        return url;

      }
    }
    

  },

  mounted: function() {
    
    this.activeStyle = mla;

    this.primeEngine();

  },
  created: function() {

    this.serverURL = __API__ || '/';

    this.retrieveFromStorage();

    const webflow = document.createElement('script');
    webflow.setAttribute('src', 'static/js/webflow.js');
    document.head.appendChild(webflow);

    const googleDrive = document.createElement('script');
    googleDrive.setAttribute('src','https://apis.google.com/js/platform.js');
    document.head.appendChild(googleDrive)

  }

})

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

//Promise Poly
require('es6-promise/auto');

// urlsearchparams poly
if (!window.URLSearchParams) {

  var js = document.createElement('script');
  js.src = "https://cdnjs.cloudflare.com/ajax/libs/url-search-params/1.0.2/url-search-params.js";
  document.head.appendChild(js);

}

window.app = app


// WEBPACK FOOTER //
// ./src/main.js